{
  "metadata": {
    "id": "dracula-dark",
    "name": "Dracula",
    "description": "Портировано из темы «Dracula» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "dracula.json",
      "project": "dracula",
      "url": "https://github.com/dracula/dracula-theme",
      "upstreamFile": "packages/ui/src/theme/themes/dracula.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 21.0,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.472,
      "paletteMaxS": 0.526,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.1,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 23.1,
      "syntaxVsTextMinDeltaE": 24.7,
      "chartsMinDeltaE": 51.7,
      "textSeparationDeltaE": 27.3,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#bd93f9",
      "hover": "#c5a0fa",
      "active": "#caa9fa",
      "foreground": "#000000",
      "muted": "#bd93f980",
      "emphasis": "#bd93f9"
    },
    "surface": {
      "background": "#1d1e28",
      "foreground": "#f8f8f2",
      "muted": "#2f313a",
      "mutedForeground": "#abacab",
      "elevated": "#383a42",
      "elevatedForeground": "#f8f8f2",
      "raised": "#515259",
      "raisedForeground": "#f8f8f2",
      "overlay": "#1d1e28cc",
      "subtle": "#262831"
    },
    "interactive": {
      "border": "#53545c",
      "borderHover": "#5a5b61",
      "borderFocus": "#bd93f9",
      "selection": "#f8f8f229",
      "selectionForeground": "#f8f8f2",
      "focus": "#bd93f959",
      "focusRing": "#bd93f961",
      "cursor": "#f8f8f2",
      "hover": "#f8f8f21c",
      "active": "#f8f8f229"
    },
    "status": {
      "error": "#ff5555",
      "errorForeground": "#000000",
      "errorBackground": "#ff555524",
      "errorBorder": "#ff555573",
      "warning": "#ffb86c",
      "warningForeground": "#000000",
      "warningBackground": "#ffb86c24",
      "warningBorder": "#ffb86c73",
      "success": "#50fa7b",
      "successForeground": "#000000",
      "successBackground": "#50fa7b24",
      "successBorder": "#50fa7b73",
      "info": "#8be9fd",
      "infoForeground": "#000000",
      "infoBackground": "#8be9fd24",
      "infoBorder": "#8be9fd73"
    },
    "pr": {
      "open": "#50fa7b",
      "draft": "#aeafae",
      "blocked": "#ffb86c",
      "merged": "#ff79c6",
      "closed": "#ff5555"
    },
    "syntax": {
      "base": {
        "background": "#404149",
        "foreground": "#f8f8f2",
        "comment": "#9aace2",
        "keyword": "#ff83ca",
        "string": "#f1fa8c",
        "number": "#c39dfa",
        "function": "#8be9fd",
        "variable": "#f8f8f2",
        "type": "#20ff23",
        "operator": "#bfc0bf"
      },
      "tokens": {
        "commentDoc": "#9aace2",
        "stringEscape": "#bfc0bf",
        "keywordImport": "#ff83ca",
        "storageModifier": "#ff83ca",
        "functionCall": "#8be9fd",
        "method": "#8be9fd",
        "variableProperty": "#8be9fd",
        "variableOther": "#f8f8f2",
        "variableGlobal": "#c39dfa",
        "variableLocal": "#bfc0bf",
        "parameter": "#f8f8f2",
        "constant": "#c39dfa",
        "class": "#20ff23",
        "className": "#20ff23",
        "interface": "#20ff23",
        "struct": "#20ff23",
        "enum": "#20ff23",
        "typeParameter": "#20ff23",
        "namespace": "#20ff23",
        "module": "#ff83ca",
        "tag": "#ff83ca",
        "jsxTag": "#ff83ca",
        "tagAttribute": "#8be9fd",
        "tagAttributeValue": "#f1fa8c",
        "boolean": "#c39dfa",
        "decorator": "#ff83ca",
        "label": "#8be9fd",
        "regexp": "#f1fa8c"
      }
    },
    "charts": {
      "series": [
        "#bd93f9",
        "#8be9fd",
        "#50fa7b",
        "#ffb86c",
        "#ff5555"
      ]
    },
    "chat": {
      "background": "#1d1e28",
      "userMessage": "#f8f8f2",
      "userMessageBackground": "#383a42",
      "assistantMessage": "#f8f8f2",
      "assistantMessageBackground": "#2f313a",
      "timestamp": "#aeafae",
      "divider": "#53545c",
      "typing": "#aeafae"
    },
    "loading": {
      "spinner": "#bd93f9",
      "spinnerTrack": "#2f313a",
      "skeleton": "#2f313a",
      "shimmer": "#4b4c53"
    },
    "tools": {
      "background": "#2f313a",
      "border": "#53545c",
      "headerHover": "#494a51",
      "icon": "#bd93f9",
      "title": "#f8f8f2",
      "description": "#aeafae",
      "edit": {
        "added": "#50fa7b",
        "addedBackground": "#50fa7b24",
        "removed": "#ff5555",
        "removedBackground": "#ff555524",
        "modified": "#8be9fd",
        "modifiedBackground": "#8be9fd24",
        "lineNumber": "#aeafae"
      }
    },
    "markdown": {
      "heading1": "#f8f8f2",
      "heading2": "#f8f8f2",
      "heading3": "#f8f8f2",
      "heading4": "#f8f8f2",
      "link": "#bd93f9",
      "linkHover": "#c5a0fa",
      "inlineCode": "#f1fa8c",
      "inlineCodeBackground": "#2f313a",
      "blockquote": "#aeafae",
      "blockquoteBorder": "#53545c",
      "listMarker": "#bd93f9bf",
      "bold": "#f8f8f2",
      "italic": "#f8f8f2e6",
      "strikethrough": "#aeafae",
      "hr": "#53545c"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c96373",
        "foreground": "#000000",
        "contrast": 5.52
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#dcbfa9",
        "foreground": "#000000",
        "contrast": 12.07
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#cd9b68",
        "foreground": "#000000",
        "contrast": 8.48
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#dbe4a8",
        "foreground": "#000000",
        "contrast": 15.67
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#acd16e",
        "foreground": "#000000",
        "contrast": 12.1
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#6dcf70",
        "foreground": "#000000",
        "contrast": 10.81
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#92dc9f",
        "foreground": "#000000",
        "contrast": 12.96
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#73c7b0",
        "foreground": "#000000",
        "contrast": 10.53
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#abd8dd",
        "foreground": "#000000",
        "contrast": 13.6
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#69afcc",
        "foreground": "#000000",
        "contrast": 8.6
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#6986c0",
        "foreground": "#000000",
        "contrast": 5.77
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#5c60c4",
        "foreground": "#ffffff",
        "contrast": 5.35
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a663c8",
        "foreground": "#000000",
        "contrast": 5.24
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#cea7da",
        "foreground": "#000000",
        "contrast": 10.16
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#ca64a4",
        "foreground": "#000000",
        "contrast": 5.87
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#dea2af",
        "foreground": "#000000",
        "contrast": 9.89
      }
    ]
  }
}
